module.exports = __webpack_public_path__ + "static/media/gammal.6c2d0b50.m4a";